import styled, { css } from "styled-components";
import { ReactComponent as HeaderIcon } from "./icons/header-logo.svg";
import { NavLink } from "react-router-dom";

export const DateContainer = styled.div`
  padding: 0px 20px;
`;

export const UserName = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #444444;
`;

export const Role = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #07a568;
`;

export const Container = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button.dropdown {
    display: flex;
    align-items: center;
    border-color: transparent;
    box-shadow: none;
    height: 64px;
    position: relative;
    gap: 10px;
    &:hover {
      background: #4d9a9a;
      border-color: #4d9a9a;
      border-radius: 0px 8px 8px 0px;
      ${UserName}, ${Role} {
        color: #ffffff;
      }
    }
    &::before {
      content: "";
      position: absolute;
      height: 45px;
      width: 1px;
      background: #f5f5f5;
      left: -5px;
    }
    ul {
      padding: 0px;
    }
  }
`;

export const HeaderLogo = styled(HeaderIcon)`
  height: 61px;
`;

export const Time = styled.div`
  font-weight: 500;
  font-size: 20px;
  color: #07a568;
  text-align: right;
`;

export const Date = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #444444;
  text-align: right;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const UserContainer = styled.div`
  text-align: left;
`;

export const UserImage = styled.img``;

export const Left = styled.div`
  height: 64px;
  display: flex;
`;
export const NavContainer = styled.nav`
  display: flex;
`;

export const NLink = styled(NavLink)<{ $disabled?: boolean }>`
  font-weight: 500;
  font-size: 20px;
  color: #003c3c;
  padding: 20px;
  gap: 10px;
  display: flex;
  align-items: center;
  height: 64px;
  min-width: 215px;

  :hover {
    color: #003c3c;
  }

  &.active {
    background: #1f5454;
    color: #ffffff;
    svg {
      fill: #ffffff;
    }
  }

  svg {
    fill: #003c3c;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.35;
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
export const Badge = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  span {
    position: absolute;
    top: -8px;
    right: -12px;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff4d4f;
    color: #ffffff;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
`;
